import { toastSuccess } from '@/lib/toast';
type Props = {
  url: string;
};
export const UrlCopyButton = ({ url }: Props) => {
  return (
    <button
      className="btn btn-outline-info btn-icon-only me-2"
      onClick={() => {
        navigator.clipboard.writeText(url).then((_) => toastSuccess('URLをコピーしました'));
      }}
    >
      <i className="fas fa-paperclip"></i>
    </button>
  );
};
